'use client';

import { type ReactNode, createContext, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { createMoneyStore, type ExchangeRate, type MoneyStore } from './moneyStore';

type MoneyStoreApi = ReturnType<typeof createMoneyStore>;

const MoneyStoreContext = createContext<MoneyStoreApi | undefined>(undefined);

export const MoneyStoreProvider = ({
	children,
	defaultCurrency,
	exchangeRates,
	currency,
}: {
	children: ReactNode;
	defaultCurrency: string;
	exchangeRates: ExchangeRate;
	currency: string;
}) => {
	const storeRef = useRef<MoneyStoreApi>(null);
	if (!storeRef.current) {
		storeRef.current = createMoneyStore(defaultCurrency, exchangeRates, currency);
	}

	return <MoneyStoreContext.Provider value={storeRef.current}>{children}</MoneyStoreContext.Provider>;
};

export const useMoneyStore = <T,>(selector: (store: MoneyStore) => T): T => {
	const moneyStoreContext = useContext(MoneyStoreContext);

	if (!moneyStoreContext) {
		throw new Error(`useMoneyStore must be used within MoneyStoreProvider`);
	}

	return useStore(moneyStoreContext, selector);
};
